export enum UserAuthorizations {
    ManageInternalReservations = "ManageInternalReservations",
    ManageOwnReservations = "ManageOwnReservations",
    ManageAllReservations = "ManageAllReservations",
    ManageGroups = "ManageGroups",
    ManageResources = "ManageResources",
    ManageResourcesMaintainance = "ManageResourcesMaintainance",
    ManageResourcesRecipients = "ManageResourcesRecipients",
    ManageResourcesTimeSlots = "ManageResourcesTimeSlots",
    ManageUsers = "ManageUsers"
}

export enum UserType {
    User = "User",
    Admin = "Admin",
    SuperAdmin = "SuperAdmin"
}

export interface UserRole {
    id: string
    code: string
    name: string
    description: string | null
    enabled: boolean
}

export interface UserDTO {
    id: string
    username: string
    firstName: string
    lastName: string
    email: string
    roleId: string
    type: string
    permissions: string[]
    enabled: boolean
    editable?: boolean
}

export interface User {
    id: string
    username: string
    firstName: string
    lastName: string
    email: string
    role: UserRole
    type: UserType
    permissions: UserAuthorizations[]
    enabled: boolean
    editable?: boolean
}

export interface UserNotification {
    notifyOnCreate: boolean
    notifyOnUpdate: boolean
    notifyOnDelete: boolean
    enabled: boolean
}